import { render } from "./ColorData.vue?vue&type=template&id=15db33d8"
import script from "./ColorData.vue?vue&type=script&lang=js"
export * from "./ColorData.vue?vue&type=script&lang=js"

import "./ColorData.vue?vue&type=style&index=0&id=15db33d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__